var _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLoadingSmall = function SvgLoadingSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "13px",
    viewBox: "0 0 128 35",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#004976",
    fillOpacity: 1,
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2700ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.167;0.5;0.668;1",
    values: "0.3;1;1;0.3;0.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#004976",
    fillOpacity: 1,
    cx: 110.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2700ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.334;0.5;0.835;1",
    values: "0.3;0.3;1;1;0.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#004976",
    fillOpacity: 1,
    cx: 64,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2700ms",
    begin: "0s",
    repeatCount: "indefinite",
    keyTimes: "0;0.167;0.334;0.668;0.835;1",
    values: "0.3;0.3;1;1;0.3;0.3"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading-small.38048833.svg";
export { ForwardRef as ReactComponent };